import { EEthereumNetworkId } from '@ankr.com/provider';
import BigNumber from 'bignumber.js';

import { ErrorMessage } from 'modules/common';
import { ContractsManager, convertFromWei } from 'modules/core';
import { api, cacheTags } from 'modules/store';

export interface GetTaskResult {
  taskId: string;
  chainId: EEthereumNetworkId;
  target: string;
  amountSpent: BigNumber;
  isPaused: boolean;
}

export const {
  useGetTaskQuery,
  endpoints: { getTask },
} = api.injectEndpoints({
  endpoints: build => ({
    getTask: build.query<
      GetTaskResult | null,
      { taskId: string; chainId: EEthereumNetworkId | null }
    >({
      queryFn: async ({ taskId, chainId }) => {
        if (!taskId) {
          return { data: null };
        }

        if (!chainId) {
          throw new Error(ErrorMessage.ChainIdIsNotDefined);
        }

        const sdk = await ContractsManager.getInstance({
          forceRead: true,
          chainId,
        });
        const contract = await sdk.getRegistryContract();
        const { amountSpent, target, isPaused } = await contract.methods
          .getTask(taskId)
          .call();

        return {
          data: {
            taskId,
            chainId,
            target,
            isPaused,
            amountSpent: convertFromWei(amountSpent),
          },
        };
      },
      providesTags: [cacheTags.taskData],
    }),
  }),
});
